import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import users from './users'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'dashboard' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () =>
            import(/* webpackChunkName: "inbox" */ '@/views/Home/Dashboard')
        },
        users,
        {
          path: 'user/:id/details',
          name: 'user.details',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/User/UserDetails'
            )
        },
        {
          path: 'reports',
          name: 'reports',
          component: () =>
            import(/* webpackChunkName: "reports" */ '@/views/Home/Reports')
        }
      ]
    }
  ]
})
